function getCurrentDateTime() {
  // This function returns the current date and time formatted as 'YYYY/MM/DD HH:mm:ss'
  const now = new Date();
  
  return now.toISOString().slice(0, 10)
}

export { getCurrentDateTime };
